/*! rangeslider.js - v2.0.0 | (c) 2015 @andreruffert | MIT license | https://github.com/andreruffert/rangeslider.js */
!function(a) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : jQuery)
}((function(a) {
  "use strict";
  function e(a) {
      return a && (0 === a.offsetWidth || 0 === a.offsetHeight || !1 === a.open)
  }
  function f(a) {
      for (var b = [], c = a.parentNode; e(c); )
          b.push(c),
          c = c.parentNode;
      return b
  }
  function g(a, b) {
      function c(a) {
          void 0 !== a.open && (a.open = !a.open)
      }
      var d = f(a)
        , e = d.length
        , g = []
        , h = a[b];
      if (e) {
          for (var i = 0; e > i; i++)
              g[i] = d[i].style.cssText,
              d[i].style.display = "block",
              d[i].style.height = "0",
              d[i].style.overflow = "hidden",
              d[i].style.visibility = "hidden",
              c(d[i]);
          h = a[b];
          for (var j = 0; e > j; j++)
              d[j].style.cssText = g[j],
              c(d[j])
      }
      return h
  }
  function h(a, b) {
      var c = parseFloat(a);
      return Number.isNaN(c) ? b : c
  }
  function i(a) {
      return a.charAt(0).toUpperCase() + a.substr(1)
  }
  function k(b, e) {
      if (this.$window = a(window),
      this.$document = a(document),
      this.$element = a(b),
      this.options = a.extend({}, o, e),
      this.polyfill = this.options.polyfill,
      this.orientation = this.$element[0].getAttribute("data-orientation") || this.options.orientation,
      this.onInit = this.options.onInit,
      this.onSlide = this.options.onSlide,
      this.onSlideEnd = this.options.onSlideEnd,
      this.DIMENSION = p.orientation[this.orientation].dimension,
      this.DIRECTION = p.orientation[this.orientation].direction,
      this.DIRECTION_STYLE = p.orientation[this.orientation].directionStyle,
      this.COORDINATE = p.orientation[this.orientation].coordinate,
      this.polyfill && n)
          return !1;
      this.identifier = "js-" + l + "-" + m++,
      this.startEvent = this.options.startEvent.join("." + this.identifier + " ") + "." + this.identifier,
      this.moveEvent = this.options.moveEvent.join("." + this.identifier + " ") + "." + this.identifier,
      this.endEvent = this.options.endEvent.join("." + this.identifier + " ") + "." + this.identifier,
      this.toFixed = (this.step + "").replace(".", "").length - 1,
      this.$fill = a('<div class="' + this.options.fillClass + '" />'),
      this.$handle = a('<div class="' + this.options.handleClass + '" />'),
      this.$range = a('<div class="' + this.options.rangeClass + " " + this.options[this.orientation + "Class"] + '" id="' + this.identifier + '" />').insertAfter(this.$element).prepend(this.$fill, this.$handle),
      this.$element.css({
          position: "absolute",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          opacity: "0"
      }),
      this.handleDown = a.proxy(this.handleDown, this),
      this.handleMove = a.proxy(this.handleMove, this),
      this.handleEnd = a.proxy(this.handleEnd, this),
      this.init();
      var f = this;
      this.$window.on("resize." + this.identifier, function d(a, b) {
          return b = b || 100,
          function() {
              if (!a.debouncing) {
                  var c = Array.prototype.slice.apply(arguments);
                  a.lastReturnVal = a.apply(window, c),
                  a.debouncing = !0
              }
              return clearTimeout(a.debounceTimeout),
              a.debounceTimeout = setTimeout((function() {
                  a.debouncing = !1
              }
              ), b),
              a.lastReturnVal
          }
      }((function() {
          !function c(a, b) {
              var c = Array.prototype.slice.call(arguments, 2);
              return setTimeout((function() {
                  return a.apply(null, c)
              }
              ), b)
          }((function() {
              f.update()
          }
          ), 300)
      }
      ), 20)),
      this.$document.on(this.startEvent, "#" + this.identifier + ":not(." + this.options.disabledClass + ")", this.handleDown),
      this.$element.on("change." + this.identifier, (function(a, b) {
          if (!b || b.origin !== f.identifier) {
              var c = a.target.value
                , d = f.getPositionFromValue(c);
              f.setPosition(d)
          }
      }
      ))
  }
  Number.isNaN = Number.isNaN || function(a) {
      return "number" == typeof a && a != a
  }
  ;
  var l = "rangeslider"
    , m = 0
    , n = function b() {
      var a = document.createElement("input");
      return a.setAttribute("type", "range"),
      "text" !== a.type
  }()
    , o = {
      polyfill: !0,
      orientation: "horizontal",
      rangeClass: "rangeslider",
      disabledClass: "rangeslider--disabled",
      horizontalClass: "rangeslider--horizontal",
      verticalClass: "rangeslider--vertical",
      fillClass: "rangeslider__fill",
      handleClass: "rangeslider__handle",
      startEvent: ["mousedown", "touchstart", "pointerdown"],
      moveEvent: ["mousemove", "touchmove", "pointermove"],
      endEvent: ["mouseup", "touchend", "pointerup"]
  }
    , p = {
      orientation: {
          horizontal: {
              dimension: "width",
              direction: "left",
              directionStyle: "left",
              coordinate: "x"
          },
          vertical: {
              dimension: "height",
              direction: "top",
              directionStyle: "bottom",
              coordinate: "y"
          }
      }
  };
  k.prototype.init = function() {
      this.update(!0, !1),
      this.$element[0].value = this.value,
      this.onInit && "function" == typeof this.onInit && this.onInit()
  }
  ,
  k.prototype.update = function(a, b) {
      (a = a || !1) && (this.min = h(this.$element[0].getAttribute("min"), 0),
      this.max = h(this.$element[0].getAttribute("max"), 100),
      this.value = h(this.$element[0].value, this.min + (this.max - this.min) / 2),
      this.step = h(this.$element[0].getAttribute("step"), 1)),
      this.handleDimension = g(this.$handle[0], "offset" + i(this.DIMENSION)),
      this.rangeDimension = g(this.$range[0], "offset" + i(this.DIMENSION)),
      this.maxHandlePos = this.rangeDimension - this.handleDimension,
      this.grabPos = this.handleDimension / 2,
      this.position = this.getPositionFromValue(this.value),
      this.$element[0].disabled ? this.$range.addClass(this.options.disabledClass) : this.$range.removeClass(this.options.disabledClass),
      this.setPosition(this.position, b)
  }
  ,
  k.prototype.handleDown = function(a) {
      if (a.preventDefault(),
      this.$document.on(this.moveEvent, this.handleMove),
      this.$document.on(this.endEvent, this.handleEnd),
      !((" " + a.target.className + " ").replace(/[\n\t]/g, " ").indexOf(this.options.handleClass) > -1)) {
          var b = this.getRelativePosition(a)
            , c = this.$range[0].getBoundingClientRect()[this.DIRECTION]
            , d = this.getPositionFromNode(this.$handle[0]) - c
            , e = "vertical" === this.orientation ? this.maxHandlePos - (b - this.grabPos) : b - this.grabPos;
          this.setPosition(e),
          b >= d && b < d + this.handleDimension && (this.grabPos = b - d)
      }
  }
  ,
  k.prototype.handleMove = function(a) {
      a.preventDefault();
      var b = this.getRelativePosition(a)
        , c = "vertical" === this.orientation ? this.maxHandlePos - (b - this.grabPos) : b - this.grabPos;
      this.setPosition(c)
  }
  ,
  k.prototype.handleEnd = function(a) {
      a.preventDefault(),
      this.$document.off(this.moveEvent, this.handleMove),
      this.$document.off(this.endEvent, this.handleEnd),
      this.$element.trigger("change", {
          origin: this.identifier
      }),
      this.onSlideEnd && "function" == typeof this.onSlideEnd && this.onSlideEnd(this.position, this.value)
  }
  ,
  k.prototype.cap = function(a, b, c) {
      return b > a ? b : a > c ? c : a
  }
  ,
  k.prototype.setPosition = function(a, b) {
      var c, d;
      void 0 === b && (b = !0),
      c = this.getValueFromPosition(this.cap(a, 0, this.maxHandlePos)),
      d = this.getPositionFromValue(c),
      this.$fill[0].style[this.DIMENSION] = d + this.grabPos + "px",
      this.$handle[0].style[this.DIRECTION_STYLE] = d + "px",
      this.setValue(c),
      this.position = d,
      this.value = c,
      b && this.onSlide && "function" == typeof this.onSlide && this.onSlide(d, c)
  }
  ,
  k.prototype.getPositionFromNode = function(a) {
      for (var b = 0; null !== a; )
          b += a.offsetLeft,
          a = a.offsetParent;
      return b
  }
  ,
  k.prototype.getRelativePosition = function(a) {
      var b = i(this.COORDINATE)
        , c = this.$range[0].getBoundingClientRect()[this.DIRECTION] + function j(a, b) {
          return a = i(a),
          void 0 !== window["page" + a + "Offset"] ? window["page" + a + "Offset"] : (document.documentElement || document.body.parentNode || document.body)["scroll" + i(b)]
      }(this.COORDINATE, this.DIRECTION)
        , d = 0;
      return void 0 !== a["page" + b] ? d = a["page" + b] : void 0 !== a.originalEvent["client" + b] ? d = a.originalEvent["client" + b] : a.originalEvent.touches && a.originalEvent.touches[0] && void 0 !== a.originalEvent.touches[0]["client" + b] ? d = a.originalEvent.touches[0]["client" + b] : a.currentPoint && void 0 !== a.currentPoint[this.COORDINATE] && (d = a.currentPoint[this.COORDINATE]),
      d - c
  }
  ,
  k.prototype.getPositionFromValue = function(a) {
      return (a && (a - this.min) / (this.max - this.min)) * this.maxHandlePos
  }
  ,
  k.prototype.getValueFromPosition = function(a) {
      var b, c;
      return b = a / (this.maxHandlePos || 1),
      c = this.step * Math.round(b * (this.max - this.min) / this.step) + this.min,
      Number(c.toFixed(this.toFixed))
  }
  ,
  k.prototype.setValue = function(a) {
      a !== this.value && this.$element.val(a).trigger("input", {
          origin: this.identifier
      })
  }
  ,
  k.prototype.destroy = function() {
      this.$document.off("." + this.identifier),
      this.$window.off("." + this.identifier),
      this.$element.off("." + this.identifier).removeAttr("style").removeData("plugin_" + l),
      this.$range && this.$range.length && this.$range[0].parentNode.removeChild(this.$range[0])
  }
  ,
  a.fn[l] = function(b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return this.each((function() {
          var d = a(this)
            , e = d.data("plugin_" + l);
          e || d.data("plugin_" + l, e = new k(this,b)),
          "string" == typeof b && e[b].apply(e, c)
      }
      ))
  }
}
)),
jQuery,
document.head.querySelector('meta[name="viewport"]').content = ( () => {
  let platform = navigator?.userAgent || navigator?.platform || "unknown";
  return /iPhone|iPod|iPad/.test(platform)
}
)() ? "width=device-width, initial-scale=1, maximum-scale=1" : "width=device-width, initial-scale=1",
$ = jQuery;
class CalculatorHistory {
  constructor() {
      this.history = []
  }
  saveCalculatorHistory(currentEntry) {
      const historyCopy = this.history.slice();
      historyCopy.unshift(currentEntry),
      this.history = historyCopy,
      this.history.length > 3 && this.history.splice(3)
  }
  displayCalculatorHistory(historyData) {
      const historyHTML = this.history.map(historyData).join("");
      setTimeout((function() {
          $("#cal-history").html(historyHTML)
      }
      ), 1500)
  }
}
let isGratuityCalculator = "gratuity";
const calculatorConstants = {
  gratuity: {
      totalInvestment: {
          default: 5e4,
          min: 1e4,
          max: 1e7
      },
      tenure: {
          default: 10,
          min: 5,
          max: 35
      }
  }
};
let totalInvestment = calculatorConstants[isGratuityCalculator].totalInvestment.default
, tenure = calculatorConstants[isGratuityCalculator].tenure.default;
const totalInvestmentHTML = document.getElementById("total-investment");
function updateGratuityTextValues() {
  const totalReturnValue = calculateGratuityReturn();
  totalInvestmentHTML.innerHTML = getOuputFormat(totalReturnValue)
}
function forceValueRanges(input, type, forceMin=!1) {
  const value = Number(removeCharsFromString(input.val()))
    , allowedMax = calculatorConstants[isGratuityCalculator][type].max
    , allowedMin = calculatorConstants[isGratuityCalculator][type].min;
  value > allowedMax && input.val(getOuputFormat(allowedMax, input.data("type"))),
  forceMin && function forceMinValues() {
      value < allowedMin && value && input.val(getOuputFormat(allowedMin, input.data("type")))
  }()
}
function calculateGratuityReturn() {
  let finGratuity = Number(totalInvestment) * Number(tenure) * 15 / 26;
  return isNaN(finGratuity) && (finGratuity = 0),
  Math.round(finGratuity)
}
function updateTextValues() {
  return updateGratuityTextValues()
}
function init() {
  updateTextValues()
}
function setHistoryValuesToInputFields(historyOBj, key) {
  $("input#investment").val(getOuputFormat(historyOBj[key].investment, "rupee")).trigger("input"),
  $("input#tenure-input").val(getOuputFormat(historyOBj[key].time, "years")).trigger("input")
}
$("input#investment").on("input", (function(event) {
  forceValueRanges($("input#investment"), "totalInvestment"),
  totalInvestment = Number(removeCharsFromString(event.target.value))
}
)),
$("input#tenure-input-slider").on("input", (function(event) {
  tenure = Number(event.target.value),
  $("input#tenure-input").val(getOuputFormat(tenure, "years"))
}
)),
$("input#tenure-input").on("input", (function(event) {
  forceValueRanges($("input#tenure-input"), "tenure"),
  tenure = Number(removeCharsFromString(event.target.value)),
  $("input#tenure-input-slider").val(tenure).change()
}
)),
$("input[type=number]").on("keydown", (function(e) {
  ["-", "+", "e"].includes(e.key) && e.preventDefault()
}
)),
$(".cal-slider .form-group input").on("input", (function() {
  updateTextValues()
}
)),
init(),
$(".calc-slide .input").on("input", (function() {
  setInput($(this))
}
));
const calHistory = new CalculatorHistory;
$("#calculate").on("click", (function() {
  $(".last-three-calculations").show(),
  calHistory.saveCalculatorHistory({
      totalReturns: calculateGratuityReturn(),
      investment: totalInvestment,
      time: tenure
  });
  let reopenIcon = document.location.origin + "/app/themes/upstox/dist/img/mutual-funds-return/view-more-icon.svg";
  calHistory.displayCalculatorHistory(( (data, index) => `<div class="expected-col" ><div class="common-col history-data">\n    <h6>Monthly Salary: <span class="invest-amount-history">${getOuputFormat(data.investment)}</span></h6>\n    <h6>No. of Years of Service: <span class="time-history">${getOuputFormat(data.time, "years")}</span></h6>\n</div>  <a href="#gratuity-calculator" class="mobile-last-calc history-cal" data-id="${index}">Re-open <img src="${reopenIcon}"></a></div>`))
}
)),
$(document).ready((function() {
  $(document).on("click", ".history-cal", (function() {
      initializeSlider();
      const key = $(this).data("id");
      setHistoryValuesToInputFields(calHistory.history, key)
  }
  ))
}
));
const getHeightOfSlide = currentChild => {
  let calHeight = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild}) > div`).height())
    , paddingTop = parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css("padding-top"));
  return calHeight + parseInt($(`#cal-slider .calc-slide:nth-child(${currentChild})`).css("padding-bottom")) + paddingTop
}
;
function initializeSlider() {
  const carouselSlides = document.querySelectorAll(".calc-slide")
    , btnNext = document.querySelector("#calculate")
    , backNext = document.querySelector("#back-button");
  let currentChild = 1
    , currentSlide = 0;
  $("#cal-slider").height(getHeightOfSlide(currentChild));
  const changeSlide = function(slides) {
      carouselSlides.forEach(( (slide, index) => {
          let pos = 100 * (index - slides);
          return index > 0 && (pos -= 100),
          slide.style.transform = `translateX(${pos}%)`
      }
      ))
  };
  changeSlide(currentSlide),
  btnNext.addEventListener("click", (function() {
      currentSlide++,
      currentChild++,
      carouselSlides.length - 1 < currentSlide && (currentSlide = 0),
      changeSlide(currentSlide),
      $("#cal-slider").height(getHeightOfSlide(currentChild)),
      setTimeout((function() {
          changeSlide(currentSlide + 2),
          currentChild++,
          $("#cal-slider").height(getHeightOfSlide(currentChild))
      }
      ), 1500)
  }
  )),
  backNext.addEventListener("click", (function() {
      carouselSlides.length - 1 < currentSlide && (currentSlide = 0),
      changeSlide(currentSlide),
      setTimeout((function() {
          changeSlide(--currentSlide),
          --currentChild,
          $("#cal-slider").height(getHeightOfSlide(currentChild))
      }
      ), 800),
      --currentChild,
      $("#cal-slider").height(getHeightOfSlide(currentChild))
  }
  ))
}
function removeCharsFromString(string) {
  return string.replace(/[^\d.]/g, "")
}
function addInput(operation, inputElement) {
  const currentValue = removeCharsFromString(inputElement.val())
    , newValue = Function(`return ${currentValue} ${operation} 1`)()
    , outputType = inputElement.data("type");
  newValue > 0 && inputElement.val(getOuputFormat(newValue, outputType)).trigger("input")
}
function setInput(currentInputElement) {
  let value = currentInputElement.val();
  const cursorPosition = currentInputElement[0].selectionStart
    , outputType = currentInputElement.data("type");
  value = removeCharsFromString(value),
  "" !== value && (value = getOuputFormat(value, outputType)),
  currentInputElement.val(value),
  "percent" != outputType && "years" != outputType || currentInputElement[0].setSelectionRange(cursorPosition, cursorPosition)
}
function getOuputFormat(value, type) {
  return "years" == type ? `${value}${value > 1 ? " years" : " year"}` : "percent" == type ? `${value}%` : "rupee" == type ? `₹ ${parseInt(Number(value))}` : "none" == type ? parseInt(Number(value)) : `₹ ${parseInt(Number(value)).toLocaleString("en-IN")}`
}
$(document).ready((function() {
  window.innerWidth < 767 && initializeSlider()
}
)),
$(".investment-main .number-tags li").on("click", (function() {
  const val = $(this).attr("value")
    , investmentInputElement = $("#investment");
  currentInvestmentValue = Number(removeCharsFromString(investmentInputElement.val())),
  investmentInputElement.val(getOuputFormat(parseInt(currentInvestmentValue) + parseInt(val))).trigger("input")
}
)),
$(".decrement").click((function() {
  addInput("-", $(this).next())
}
)),
$(".increment").click((function() {
  addInput("+", $(this).prev())
}
)),
function($) {
  $(document).ready((function() {
      $(".dynamic-faq").on("click", ".panel-trigger", (function() {
          var val = $(this).attr("val");
          $(".dynamic-faq").find(`.panel-collapse:not(${val})`).slideUp("fast");
          var inactiveTab = $(".dynamic-faq").find(`.panel-trigger:not([val="${val}"])`);
          $(this).toggleClass("collapsed"),
          $(val).slideToggle("fast"),
          inactiveTab.hasClass("collapsed") && inactiveTab.removeClass("collapsed")
      }
      )),
      $(".btn-all").click((function() {
          $(".smooth-wrap").addClass("smooth-wrap2"),
          $(".btn-all").hide(),
          $(".btn-less").show()
      }
      )),
      $(".btn-less").click((function() {
          $(".smooth-wrap").removeClass("smooth-wrap2"),
          $(".btn-all").show(),
          $(".btn-less").hide()
      }
      ))
  }
  ))
}(jQuery);
//# sourceMappingURL=gratuity.js.map
